import { useState, useEffect, useMemo } from "react";

export const getTimeLeft = (target) => {
  const diff = target - Date.now();
  if (diff <= 0) return null;
  
  const days = Math.floor(diff / 86400000);
  const hours = Math.floor((diff / 3600000) % 24);
  const minutes = Math.floor((diff / 60000) % 60);
  const seconds = Math.floor((diff / 1000) % 60);
  
  const timeObj = {};
  
  if (days > 0) {
    timeObj.days = String(days).padStart(2, "0");
  }
  
  if (days > 0 || hours > 0) {
    timeObj.hours = String(hours).padStart(2, "0");
  }
  
  if (days > 0 || hours > 0 || minutes > 0) {
    timeObj.minutes = String(minutes).padStart(2, "0");
  }
  
  timeObj.seconds = String(seconds).padStart(2, "0");
  
  return timeObj;
};

export const useOfferBanner = (config) => {
  const endTarget = config?.end_timestamp;
  const startTarget = config?.start_timestamp;
  
  const checkVisibility = () => {
    if (config?.enable_banner === false) return false;
    const now = Date.now();
    const isStarted = !startTarget || startTarget <= now;
    const isNotEnded = !endTarget || endTarget > now;
    return !!(config && isStarted && isNotEnded);
  };

  const [isVisible, setIsVisible] = useState(checkVisibility);

  const [timeLeft, setTimeLeft] = useState(() => {
    if (!checkVisibility() || !config?.show_timer || !endTarget) return null;
    return getTimeLeft(endTarget);
  });

  useEffect(() => {
    if (config?.enable_banner === false || !config) {
      setIsVisible(false);
      return;
    }

    const update = () => {
      const visible = checkVisibility();
      setIsVisible(visible);
      
      if (visible && config?.show_timer && endTarget) {
        setTimeLeft(getTimeLeft(endTarget));
      } else {
        setTimeLeft(null);
      }
    };

    update();
    const interval = setInterval(update, 1000);
    return () => clearInterval(interval);
  }, [config?.enable_banner, config?.show_timer, startTarget, endTarget]);

  return { isVisible, timeLeft };
};
